import { type RequestContext } from '@cx-web/domain-types';

import {
  type BettingInsightsConfigFactoryOptions,
  type PlayerDataIndex,
  type PlayerDataResult,
} from '~/apps/product-plus/configuration/types';
import {
  type BettingInsightsUIConfig,
  createBettingInsightsUIConfig,
} from '~/apps/product-plus/configuration/ui/BettingInsightsUI';

export function createPlayerDataUIConfig(
  requestContext: RequestContext,
  _options: BettingInsightsConfigFactoryOptions = {},
  tags: string[],
) {
  const uiConfig: BettingInsightsUIConfig<PlayerDataIndex, PlayerDataResult> = {
    card: {
      styles: {},
      table: {
        body: {
          render(_context, { content }) {
            return (
              <div className="player-prop-stats">
                <div>Player ID: {content.sportsData.participant!.participantId}</div>
                <div>Player Name: {content.sportsData.participant!.name}</div>
              </div>
            );
          },
        },
        footer: {
          render(_context) {
            return null;
          },
        },
        getContent(_context, { result }) {
          return [result];
        },
        headings: {
          row: 1,
          content: [],
        },
        main: {
          render(_context) {
            return null;
          },
        },
        cells: [],
      },
      title: {
        format: '{sportsData.participant.name} | {sportsData.participant.nickName}',
      },
      wrapper(_context, { children }) {
        return <div>{children}</div>;
      },
    },
    initialUiState(_context) {
      return {};
    },
    refinements: {
      clearAll: {
        excludedAttributes: [],
      },
      components: [],
    },
    results: {
      categories() {
        return {
          attribute: 'sportsData.participant.participantId',
          labels: {},
          order: {
            start: [],
            end: [],
          },
        };
      },
      labelledBy: '#player-data-title',
      propsName: 'playerStats',
    },
    search: {
      render(_context) {
        return null;
      },
    },
    sorting: {
      canSort() {
        return false;
      },
    },
  };

  return {
    ui: createBettingInsightsUIConfig(requestContext, uiConfig, tags),
  };
}
